import React from "react";

import { useSelector } from "react-redux";
import MasterContractDetails from "./MasterContractDetails";

const MasterContractList = () => {
	const { masterContracts } = useSelector((state) => state.admin);
	console.log("masterContracts", masterContracts);

	return (
		<>
			{masterContracts
				.filter((i) => !i.isDeprecated)
				.map((contract) => (
					<MasterContractDetails id={contract._id} key={contract._id} />
				))}
		</>
	);
};

export default MasterContractList;
